import { CustomPropertiesReader } from './custom-properties/CustomPropertiesReader';

export { CustomPropertiesPlugin } from './custom-properties';
export const customPropertiesReader = new CustomPropertiesReader();
